import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledPageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'noPadding',
})<{ noPadding: boolean }>(({ theme, noPadding }) => ({
  backgroundColor: theme.palette.grey[100],
  flexGrow: 1,
  padding: noPadding ? 0 : 16,
  display: 'flex',
  justifyContent: 'center',
  minWidth: 200,
  paddingLeft: noPadding ? 0 : 32,
}))

type PageContentProps = {
  maxWidth: number | string
}
const PageContent = styled(Box)<PageContentProps>(({ maxWidth }) => ({
  flexGrow: 1,
  width: '100%',
  maxWidth,
}))

type Props = {
  maxWidth?: number | string
  children?: React.ReactNode
  noPadding?: boolean
}

export const PageWrapper = (props: Props) => {
  const maxWidth = props.maxWidth || 1200

  return (
    <StyledPageWrapper id="pagewrapper" noPadding={props?.noPadding || false}>
      <PageContent maxWidth={maxWidth}>{props.children}</PageContent>
    </StyledPageWrapper>
  )
}
